<template>
  <div class="container">
    <div class="card cardContainer">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <h2 class="text-center text-white">Wähle dein Homepagedesign</h2>
          </div>
        </div>
        <div class="row my-1">
          <div class="col-12 d-flex align-content-center flex-wrap justify-content-center">
            <div :class="theme.ThemeID === form.themeId ? 'card cardAssetActive' : 'card cardAsset'"
              v-for="(theme, themeIndex) in themeList" :key="'theme_' + themeIndex">
              <div class="card-header">
                {{ theme.ThemeName }}
              </div>
              <div class="card-body">
                <img class="imgThumbnail" :src="assetBasePath + '/' + level + '/' + theme.Folder + '/' + theme.Image"
                  @click="themeDetail(theme.ThemeID)" :alt="'themeImg_' + theme.ThemeID" />
              </div>
              <div class="card-footer d-flex justify-content-center">
                <template v-if="theme.ThemeID === form.themeId">
                  <span>Ausgewählt</span>
                </template>
                <template v-else>
                  <button class="btn btn-success btn-sm" @click="selectTheme(theme.ThemeID)">
                    Wählen
                  </button>
                </template>
              </div>
              <div class="modal fade" :id="'themeDetail_' + theme.ThemeID" tabindex="-1"
                :aria-labelledby="'themeDetailLbl_' + theme.ThemeID" aria-hidden="true">
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" :id="'themeDetailLbl_' + theme.ThemeID"></h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <img class="themeDetailImg"
                            :src="assetBasePath + '/' + level + '/' + theme.Folder + '/sample.jpg'"
                            :alt="'imgDetail_' + (themeIndex + 1)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-1">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary" :disabled="form.themeId === null" @click="save">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "UserFirstTheme",
  data() {
    return {
      themeList,
      indexPageUrl,
      assetBasePath,
      themeSaveUrl,
      level,
      form: {
        themeId: null
      }
    }
  },
  mounted() { },
  created() { },
  methods: {
    selectTheme(themeId) {
      this.form.themeId = themeId;
    },
    themeDetail(themeId) {
      $("#themeDetail_" + themeId).modal('show');
    },
    save() {
      Lobibox.confirm({
        title: 'Kostenlos kaufen',
        msg: 'Bist du dir sicher?',
        buttons: {
          ok: {
            class: 'btn btn-success',
            text: 'Ja',
            closeOnClick: true
          },
          cancel: {
            class: 'btn btn-danger',
            text: 'Nein',
            closeOnClick: true
          }
        },
        callback: (lobibox, type, state) => {
          if (type === 'ok') {
            $("body").addClass("loading");
            axios.post(this.themeSaveUrl, this.form)
              .then((response) => {
                if (response.data.status === 'success') {
                  console.log(response);
                  window.location.href = this.indexPageUrl;
                }
              })
              .catch((response) => {
                console.log(response);
              });
          }
        }
      });
    }
  },
  watch: {}
};
</script>
<style scoped>
.cardContainer {
  margin-top: 6vw;
  border-radius: 2.5rem;
  background: rgba(143, 143, 143, .6);
}

.cardAssetActive {
  border: 4px solid #67ad06ed;
  width: 275px;
  max-height: 400px;
  padding: 0 5px;
  margin: 5px;
  border-radius: 15px;
}

.imgThumbnail {
  min-width: 50px;
  width: 100%;
  max-height: 250px;
  cursor: pointer;
}

.cardAsset {
  width: 275px;
  max-height: 400px;
  padding: 0 5px;
  margin: 5px;
  border-radius: 15px;
}

.themeDetailImg {
  max-width: 100%;
}
</style>
